import { MapPinIcon } from '@interstate/components/Icons/MapPinIcon';
import { Tooltip } from '@interstate/components/Tooltip';
import type { ProgramQuote } from '@makemydeal/dr-dash-types';
import type { ReactNode } from 'react';

export const renderProgramTypeCell =
    (textFormatter: (record: ProgramQuote) => string, tooltipFormatter: (record: ProgramQuote) => string) =>
    (_: unknown, record: ProgramQuote): ReactNode =>
        (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', overflow: 'hidden' }}>
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{textFormatter(record)}</span>
                {tooltipFormatter(record) && (
                    <Tooltip position="bottom" toolTipContent={tooltipFormatter(record)} size="large">
                        <MapPinIcon data-testid="program-type-regional-title-icon" width={16} height={16} color="#318ad3" />
                    </Tooltip>
                )}
            </span>
        );
